export default __webpack_public_path__ + "static/media/2image.7781f400.png";